var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{ref:"mapBox",staticClass:"mapContainer",attrs:{"id":"amap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }